import { nonEmpty } from "@swo/shared";
import type { BundleElement, SwarovskiOptikClientCartLineItem } from "@swo/storefront";
import type { NonEmptyArray } from "fp-ts/lib/NonEmptyArray";

export type FrontendLineItemAttribute = {
  label: string;
  type: "plain" | "color";
  customValue?: string | undefined; // eg. hex value for color attributes
};

export function getLineItemAttributes(lineItem: SwarovskiOptikClientCartLineItem): Array<FrontendLineItemAttribute> {
  if (lineItem.data.tag === "bundle") {
    return getBundleElementAttributes(lineItem.data.bundleElements);
  }

  return lineItem.data.variant.uniqueAttributes.map(a => ({
    label: a.value.label,
    type: a.value.type === "color" ? "color" : "plain",
    customValue: a.value.customValue,
  }));
}

export function getBundleElementAttributes(
  bundleElements: NonEmptyArray<BundleElement>,
): Array<FrontendLineItemAttribute> {
  return bundleElements.map(_ => {
    let ret = _.name;

    const attributes = _.variant.uniqueAttributes.map(a => a.value.label).filter(nonEmpty);

    if (attributes.length > 0) {
      ret += " " + attributes.join(", ");
    }

    return {
      label: ret,
      type: "plain",
      customValue: undefined,
    };
  });
}
